import { useTranslation } from "react-i18next";

import CustomModal from "@components/CustomModal";

import useManageGroup from "./hooks/useManageGroup";
import ManageGroupView from "./view";

export default function ManageGroupModal({ modalRef }) {
    const { t } = useTranslation("groupModals");
    const {
        open,
        loading,
        type,
        configRef,
        communityRef,
        uploadBusy,
        errors,
        clearError,
        handleSubmit,
        handleDelete,
        handleClose,
        handleTypeChange,
        handleAvailabilityChange,
        handleUploadBusyChange,
    } = useManageGroup({ modalRef });

    const isEditing = !!configRef.current?.id;

    return (
        <CustomModal
            maxWidth={530}
            bottomButtonSumbitText={t("manageGroup.submit")}
            bottomButtonCancelText={t("common:actions.cancel")}
            loading={loading}
            disabled={uploadBusy}
            handleDelete={isEditing ? handleDelete : null}
            deletionTitle={t("manageGroup.deletionTitle")}
            title={
                isEditing
                    ? t("manageGroup.editTitle")
                    : t("manageGroup.createTitle")
            }
            handleSubmit={handleSubmit}
            open={open}
            className="config-group-modal"
            handleClose={handleClose}
            bodyComponent={
                open ? (
                    <ManageGroupView
                        configRef={configRef}
                        communityRef={communityRef}
                        type={type}
                        errors={errors}
                        clearError={clearError}
                        onTypeChange={handleTypeChange}
                        onAvailabilityChange={handleAvailabilityChange}
                        onUploadBusyChange={handleUploadBusyChange}
                    />
                ) : null
            }
        />
    );
}
